<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl
						? `master/teaching-type/${inputs.teaching_type_id}`
						: `master/teaching-type`
				"
			>
				<div class="form-group row align-items-center">
					<label
						for="inputs_type_id"
						class="col-sm-3 mb-0"
					>
						Teaching Type ID
					</label>
					<app-input
						id="inputs_type_id"
						class="col-sm-9"
						type="text"
						v-model="inputs.type_id"
						:placeholder="'Teaching Type ID'"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label
						for="inputs_teaching_type_code"
						class="col-sm-3 mb-0"
					>
						Teaching Type Code
					</label>
					<app-input
						id="inputs_teaching_type_code"
						class="col-sm-9"
						type="text"
						v-model="inputs.teaching_type_code"
						:placeholder="'Teaching Type Code'"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label
						for="inputs_teaching_type_desc"
						class="col-sm-3 mb-0"
					>
						Teaching Type Desc
					</label>
					<app-input
						id="inputs_teaching_type_desc"
						class="col-sm-9"
						type="text"
						v-model="inputs.teaching_type_desc"
						:placeholder="'Teaching Type Desc'"
						:required="true"
					/>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";

export default {
	name: "ModalForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {
					id: undefined,
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			inputs: {
			},
			modalId: this.formId,
			modalTitle: this.$t("add"),
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	methods: {
		submit() {
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			if (response.data.phone) this.phone = response.data.phone;
			this.inputs = response.data;
			this.preloader = false;
		},
	},
};
</script>
